import { INSURANCE_V3_ROUTES } from '@/views/insurance/config/insuranceV3Routes';

export default function isDriversV3({ next, store, nextMiddleware }) {
  if (!store.GET_CONNECT_ID) {
    return next({
      name: INSURANCE_V3_ROUTES.drivers,
    });
  }

  return nextMiddleware();
}
